module.exports = __webpack_public_path__ + "img/EladioGuevara.f947183d.jpg";